import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect, useState } from 'react';
import { XIcon } from '../../icon/icon';
import { OnOffButton } from '../../items/on.off.button';
import { InputBtn } from '../../items/inputBtn';

const settingItem = [
  {
    label: '요소수',
    value: true,
  },
  {
    label: '주유',
    value: true,
  },
  {
    label: '운행거리',
    value: true,
  },
];

const settingCompanyItem = [
  {
    label: '청수(물차)',
    value: true,
  },
  {
    label: '폐수',
    value: true,
  },
  {
    label: '지연',
    value: true,
  },
  {
    label: 'L/km',
    value: true,
  },
  {
    label: 'km/L',
    value: true,
  },
  {
    label: '요소수',
    value: true,
  },
  {
    label: '실제 주유량',
    value: true,
  },
];

interface SearchConditionProps {
  handleSearchClose: () => void;
  onSaveSettings: (settings: boolean[]) => void;
  initialSwitchStates: boolean[]; // 초기 스위치 상태값
  selectType?: string;
}

export const UserInputSetting = ({
  handleSearchClose,
  onSaveSettings,
  initialSwitchStates,
  selectType = 'belonged',
}: SearchConditionProps) => {
  const { register, handleSubmit } = useForm();
  const [switchStates, setSwitchStates] =
    useState<boolean[]>(initialSwitchStates);

  useEffect(() => {
    console.log('Switch States:', switchStates);
  }, [switchStates]);

  const toggleSwitch = (index: any) => {
    setSwitchStates((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };
  const onSubmit = (data: any) => {
    onSaveSettings(switchStates);
    handleSearchClose();
  };
  return (
    <Container selectType={selectType}>
      <motion.div
        className="wrapper"
        initial={{ y: '100%' }}
        animate={{ y: '0%' }}
        exit={{ y: '100%' }}
        transition={{
          type: 'spring',
          stiffness: 400,
          damping: 40,
        }}
      >
        <div className="overlay" onClick={handleSearchClose}></div>
        <div className="wrap-shape">
          <div className="header">
            <span>입력 설정</span>
            <div className="icon-box" onClick={handleSearchClose}>
              <XIcon />
            </div>
          </div>
          <div className="body">
            <form onSubmit={handleSubmit(onSubmit)}>
              {selectType === 'belonged' ? (
                <ul>
                  {settingItem.map((item, index) => (
                    <li key={index}>
                      <div className="label">
                        <label htmlFor="name">{item.label}</label>
                      </div>
                      <div className="input">
                        <OnOffButton
                          isOn={switchStates[index]}
                          toggleSwitch={() => toggleSwitch(index)}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <ul>
                  {settingCompanyItem.map((item, index) => (
                    <li key={index}>
                      <div className="label">
                        <label htmlFor="name">{item.label}</label>
                      </div>
                      <div className="input">
                        <OnOffButton
                          isOn={switchStates[index]}
                          toggleSwitch={() => toggleSwitch(index)}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              <InputBtn name="설정" type="submit" />
            </form>
          </div>
        </div>
      </motion.div>
    </Container>
  );
};

// style
const Container = styled.div<{ selectType: string }>`
  display: flex;
  align-items: flex-end;
  height: 100%;
  position: relative;
  .wrapper {
    width: 100%;
    height: 100%;
    .wrap-shape {
      background: ${(props) => props.theme.textWhiteColor};
      border-radius: 2rem 2rem 0 0;
      overflow: hidden;
      height: ${(props) =>
        props.selectType === 'belonged' ? '35.6rem' : '55.4rem'};
      width: 100%;
      position: absolute;
      bottom: 0;
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.8rem 0.4rem 0.6rem 2.2rem;
        span {
          font-size: 1.7rem;
          font-weight: 600;
        }
        .icon-box {
          display: flex;
        }
      }
      .body {
        form {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 1.2rem;
          ul {
            display: flex;
            flex-direction: column;
            li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px solid ${(props) => props.theme.gray300};
              padding: 1.3rem 2.1rem 1.3rem 2.7rem;
              .label {
                label {
                  font-size: 1.6rem;
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }
  }
`;
